<div class="ui card">
  <div class="content">
    <div class="header">{{ value }}</div>
    <div class="description">
      {{ header }}
    </div>
  </div>
</div>
